import type { Translation } from "./types";

const es: Translation = {
  home: {
    title: "Supaplate",
    subtitle: "Es hora de construir!",
    loginButton: "Iniciar sesión",
    gymSelectionButton: "Seleccionar gimnasio",
  },
  gameSelection: {
    searchButtonTitle: "Buscar",
    disqualifiedFailedMessage: "Descalificado. Por favor, contacte al equipo de control o técnico.",
    disqualifiedSuccessMessage: "Descalificado exitosamente",
    umpireSaveFailedMessage: "Guardado de árbitro fallido. Por favor, inténtelo de nuevo, y si el problema persiste, contacte al equipo de control o técnico.",
    ofTeam: "Equipo de",
    startGameSuccessTitle: "Iniciar juego",
    startGameSuccessDescription: "Juego iniciado",
    startGameSuccessActionText: "OK",
    playerCallSuccessTitle: "Llamar jugador",
    playerCallSuccessDescription: "Jugador llamado",
    playerCallSuccessActionText: "OK",
    noPlayerAlertTitle: "No hay jugador",
    noPlayerAlertDescription: "No hay jugador. Por favor, verifique el número de juego y el tipo de juego nuevamente, y si el error persiste, contacte al administrador.",
    noPlayerAlertActionText: "OK",
    noPlayerAlertCancelText: "Cancelar",
    noPlayerAlertConfirmText: "OK",
    disqualifiedSuccessTitle: "Descalificado exitosamente",
    disqualifiedSuccessActionText: "OK",
    errorTitle: "Error",
    errorDescription: "Error ocurrido. Por favor, inténtelo de nuevo, y si el problema persiste, contacte al equipo de control o técnico.",
    errorActionText: "OK",
    noMatchTitle: "No hay juego",
    noMatchDescription: "No hay juego encontrado.",
    noMatchActionText: "OK",
    noUmpireAlertTitle: "No hay árbitro",
    noUmpireAlertDescription: "Por favor, seleccione o ingrese el árbitro.",
    noUmpireAlertActionText: "OK",
    noUmpireAlertCancelText: "Cancelar",
    courtTitle: "Pista",
    court: "Pista",
    match: "Juego",
    loadMatchTitle: "Cargar juego",
    byOrder: "Orden de pista",
    byTimetable: "Horario",
    byNumber: "Ingresar número",
    byMatchNumber: "Número de partido",
    byOrderDescription: "Puedes seleccionar un juego en esta pista.",
    byTimetableDescription: "Puedes seleccionar un juego de otras pistas programadas.",
    byNumberDescription: "Puedes seleccionar un juego ingresando el número de juego.",
    byMatchNumberDescription: "Ver todos los partidos ordenados por número de partido.",
    searchMatchCheckboxTitle: "Incluir juegos completados",
    searchMatchButtonTitle: "Buscar juego",
    previousMatchButtonTitle: "Juego anterior",
    nextMatchButtonTitle: "Juego siguiente",
    noMatchSearchMatchGuide: "Haz clic en el botón de búsqueda de juego para encontrar un juego.",
    timetableSearchMatchGuide: "Puedes seleccionar un juego de otras pistas programadas.",
    matchListTitle: "Lista de juegos",
    matchListLoading: "Cargando lista de juegos...",
    matchNumberTitle: "Número de juego",
    personalMatchTitle: "Juego personal",
    teamMatchTitle: "Juego de equipo",
    goToMatchButtonTitle: "Ir al juego",
    teamMatchOrderTitle: "Orden de juego de equipo",
    checkMatchandPlayerTitle: "Ver juego y jugador",
    backButtonTitle: "Volver",
    viewSubMatchButtonTitle: "Ver juego secundario",
    umpireInputDescription: "Por favor, seleccione o ingrese el árbitro.",
    umpireInputPlaceholder: "Seleccionar árbitro",
    umpireInputDirection: "Escribir nombre del árbitro",
    umpire: "Árbitro",
    umpireSaveButtonTitle: "Guardar",
    umpireErrorMessage: "Por favor, ingrese el árbitro. Necesita ingresar el árbitro para iniciar el juego.",
    GotoSettingButtonTitle: "Ir a la configuración de posición",
    notReadyPlayerWalkoutButtonTitle: "Jugador no listo se retirará",
    walkoverTitle: "Retirado",
    walkoverBothTeamTitle: "Ambos equipos se retiran.",
    walkoverDescription: "se retiran en este juego.",
    walkoverActionText: "Retirado",
    walkoverCancelText: "Cancelar",
    playerCheckDescription: "Toca la tarjeta de jugador que ha entrado a la pista.",
    playerCallTitle: "Llamar jugador",
    playerCallDescription: "¿Quieres llamar al jugador?",
    playerCallActionText: "OK",
    playerCallCancelText: "Cancelar",
    playerCallLoading: "Llamando...",
    playerCallButtonTitle: "Llamar jugador",
    playerReadyButton: "Jugador(es) listo(s)",
  },
  gameStart: {
    gameStartTitle: "Configuración de posición",
    warmUpCompleteButtonTitle: "Completar",
    warmUpBackButtonTitle: "Volver",
    stopButtonTitle: "Detener",
    startButtonTitle: "Iniciar",
    startGameButtonTitle: "Iniciar juego",
    colorSelectTitle: "Seleccionar color",
    selectedColor: "Color seleccionado",
    orderTitle: "Orden",
    positionTitle: "Posición",
  },
  gamePlay: {
    disqualifiedTitle: "Descalificado",
    retiredTitle: "Retirado",
    gamePlayTitle: "Juego en progreso",
    undoButtonTitle: "Deshacer",
    matchEndTitle: "Fin de juego",
    gameEndTitle: "Fin de juego",
    conductGameTitle: "Conduct Game",
    conductMatchTitle: "Conduct Match",
    walkoverTitle: "Walkover",
    matchEndDescription: "El juego se completará. ¿Desea continuar?",
    gameEndDescription: "El juego actual se completará y se iniciará el siguiente juego. ¿Desea continuar?",
    matchEndButtonTitle: "Fin de juego",
    gameEndButtonTitle: "Fin de juego",
    nextGameButtonTitle: "Siguiente juego",
    errorTitle: "Error",
    errorDescription: "Error ocurrido. Por favor, inténtelo de nuevo, y si el problema persiste, contacte al equipo de control o técnico.",
    errorActionText: "OK",
    positionChangeTitle: "Cambio de posición",
    winnerTeam: "Ganador",
    loserTeam: "Perdedor",
    positionChangeDescription: "¿Quieres cambiar la posición?",
    positionChangeActionText: "Cambiar",
  },
  gamePlayButtonGroup: {
    injuryTimeTitle: "Tiempo de lesión",
    injuryTimeResumeButtonTitle: "Reanudar",
    injuryTimePauseButtonTitle: "Pausar",
    injuryTimeResetButtonTitle: "Reiniciar",
    misconductDescription: "Por favor, presione el botón a continuación para registrar el misconduct.",
  },
  matchSettingDialog: {
    title: "Configuración de juego",
    numOfSetsTitle: "Número de sets",
    pointsPerSetTitle: "Puntos por set",
    numOfSetsDescription: "Configura el número de sets en este juego.",
    pointsPerSetDescription: "Configura los puntos por set en este juego.",
  },
  navigationBar: {
    callOperatorButtonTitle: "Llamar operador",
    callOperatorSuccessTitle: "Llamada exitosa",
    callOperatorSuccessDescription: "Llamada exitosa. Por favor, espere un momento.",
    callOperatorSuccessActionText: "OK",
  },
  gymSelection: {
    gymSelectionTitle: "Selección de gimnasio",
    selectDateTitle: "Seleccionar fecha",
    tournametDateTitle: "Fecha del torneo",
    selectGymTitle: "Seleccionar pista",
  },
  courtSelection: {
    courtSelectionTitle: "Selección de pista",
    courtSelectionInfo: "Selecciona una pista para entrar a la pista",
    courtTitle: "Pista",
    umpireButtonTitle: "Árbitro",
    scoreViewButtonTitle: "Puntuación",
    liveScoreButtonTitle: "Todas las pistas de puntuación en vivo",
    scoreboardDisplayButtonTitle: "Pantalla de Marcador",
  },
  navigation: {
    en: "Inglés",
    kr: "Coreano",
    es: "Español",
  },
  days: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
};

export default es;
